import type {ConversationContext} from '@stripe-internal/conversations-client';
import isEqual from 'fast-deep-equal';

import type {ConversationsApiDataConversationOverview} from './generated/types';

export type ConversationOverview = ConversationsApiDataConversationOverview;

type OverviewContext = ConversationContext & {
  conversationOverview?: ConversationOverview;
};

export function getConversationOverview(
  context?: ConversationContext,
): ConversationOverview | undefined {
  return (context as OverviewContext | undefined)?.conversationOverview;
}

/** Return context with a complete, identity-validated server snapshot applied. */
export function withConversationOverview(
  conversationId: string,
  context: ConversationContext,
  incoming?: ConversationOverview,
): OverviewContext {
  const existing = getConversationOverview(context);
  const current = existing?.id === conversationId ? existing : undefined;
  const base =
    existing && !current
      ? {...context, conversationOverview: undefined}
      : context;
  if (!incoming || incoming.id !== conversationId) return base;
  return isEqual(current, incoming)
    ? base
    : {...base, conversationOverview: incoming};
}
